import React, { useState, useEffect } from "react";

import "./sidemenu.css";
import contentFile from "../../constants/contentFile.json";
import { useNavigate, useLocation } from "react-router-dom";
import ToggleArrow from "../../assets/images/Toggle-arrow.svg";
import CodelynksIcon from "../../assets/images/icons/codelynksIcon.svg";

const Sidemenu = () => {
  const menuList = contentFile.sidemenu;
  const navigate = useNavigate();
  const location = useLocation();

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const [acitveItem, setActiveItem] = useState(location.pathname);
  const [collapseActive, setCollapseActive] = useState(false);
  const [leftBtnHide, setLeftBtnHide] = useState(false)

  const sidemenuCollapse = (e) => {
    setCollapseActive(!collapseActive);
  };

  const filteredMenuList = menuList.filter((menu) => {
    // Always show the Dashboard
    // if (menu.label === "Dashboard") return true;

    if (!menu.featureId) return true; // Show menu without a featureId
    const permission = permissions.find((p) => p.feature === menu.featureId);
    return permission?.view === true; // Show if view is true
  });

  useEffect(() => {

    const activeMenu = menuList.find((menu) =>
     
      location.pathname.startsWith(menu.path)
    );
    if (location?.pathname == activeMenu?.path) {
     setLeftBtnHide(true)
    }else{
      setLeftBtnHide(false)
    }
    setActiveItem(activeMenu?.path || ""); // Set the active menu path
  }, [location.pathname, menuList, leftBtnHide]);


  return (
    <div className="sidemenu-page">
              <button disabled={leftBtnHide} type="button" onClick={() => navigate(-1)} class="navbar-btn">
          <img src={ToggleArrow} alt="toggle-arrow" />
        </button>
      <nav id="sidebar" class={collapseActive ? "active" : ""}>
        <ul class="list-unstyled components">
          {filteredMenuList.map((menu, index) => {
            return (
              <li
                className={acitveItem === menu.path ? "active-item" : ""}
                key={index}
                onClick={() => {
                  setActiveItem(menu.path);
                  navigate(menu.path);
                }}
              >
                <i className={menu.className}></i>
                <span>{menu.label}</span>
              </li>
            );
          })}
        </ul>
      </nav>
      <span className="codelynks-Icon">
        <img src={CodelynksIcon} alt="Codelynks-Icon" />
      </span>
    </div>
  );
};

export default Sidemenu;
